<template>
  <div v-if="impersonationStore.isImpersonating" class="impersonation-banner">
    <span class="banner-label">SUPPORT VIEW</span>
    <span class="banner-text">
      Viewing <strong>{{ impersonationStore.workspaceName }}</strong> as staff
      <span v-if="impersonationStore.isReadOnly" class="read-only-tag">read-only</span>
    </span>
    <button class="exit-btn" @click="handleExit">Exit <Icon name="close" size="sm" /></button>
  </div>
</template>

<script setup lang="ts">
import { useImpersonationStore } from '@/stores/impersonation'
import Icon from '@/components/shared/Icon.vue'
import { useRouter } from 'vue-router'

const impersonationStore = useImpersonationStore()
const router = useRouter()

async function handleExit() {
  await impersonationStore.endImpersonation()
  router.push({ name: 'login' })
}
</script>

<style scoped>
.impersonation-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  background: #7c3aed;
  color: white;
  font-size: 13px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.banner-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  background: rgba(255,255,255,0.2);
  padding: 2px 8px;
  border-radius: 4px;
  flex-shrink: 0;
}

.banner-text {
  flex: 1;
}

.banner-text strong {
  font-weight: 600;
}

.read-only-tag {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.05em;
  background: rgba(255,255,255,0.15);
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
}

.exit-btn {
  flex-shrink: 0;
  padding: 5px 14px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 6px;
  color: white;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.exit-btn:hover {
  background: rgba(255,255,255,0.25);
}
</style>
